import { makePATCHRequest, makePOSTRequest } from "../request/rawRequest";
import { paramsSingup } from "../types/types";
import { getCurrentTechnoOrDisconnect } from "../variables/jobDictionnary";

export const signUp = async (
  params: paramsSingup,
  setMessage: React.Dispatch<React.SetStateAction<string | undefined>>
): Promise<void> => {
  await makePOSTRequest("/register", params)
    .then(async (response) => {
      localStorage.setItem("authToken", response.authToken);

      await makePATCHRequest("/pole?pole=" + getCurrentTechnoOrDisconnect())
        .then((response) => {
          window.location.reload();
        })
        .catch((error) => {
          localStorage.removeItem("authToken");
        });
    })
    .catch((error) => {
      console.error(error.response);
      setMessage("erreur : " + error.response.data.error);
    });
};
